export var getNextSegment = function (segments, index) { var _a; return (_a = segments[index + 1]) === null || _a === void 0 ? void 0 : _a.segment; };
